<template>
  <div class="out_stock">
    <div class="stock_title">
      <h2>Out of stock</h2>
      <p>Some items are no longer available. Your cart has been updated.</p>
    </div>
    <div class="section">
      <div class="section_head clearfix">
        <span>Description</span>
        <em>Quantity</em>
      </div>
      <ul class="stock_list">
        <li class="stock_list_item" v-for="item in out_stock" :key="item.key">
          <div class="product_img">
            <img
              :src="item.variant?item.variant.feature_image?item.variant.feature_image.thumbnail:item.product.feature_image?item.product.feature_image.thumbnail:defaultImage:item.product.feature_image?item.product.feature_image.thumbnail:defaultImage"
              @error.once="imageFailure"
              class="lazyload"
              alt
            />
            <span>{{item.quantity}}</span>
          </div>
          <div class="product_name">
            <p>{{item.product.post_title}}</p>
            <p class="variant" v-if="item.variant">
              <span
                v-for="(subitem,subindex) in item.variant.attrs"
                :key="subindex"
              >{{subitem.value}}</span>
            </p>
          </div>
          <div class="product_num">
            <span v-if="item.variant?item.variant.stock==0:item.product.stock==0" class="stock_0">
              <span class="iconfont icon-jinzhi"></span> Sold out
            </span>
            <span class="stock_not_enough" v-else>
              {{item.quantity}} →{{item.variant?item.variant.stock:item.product.stock}}
              <span
                class="iconfont icon-cha2"
                @click="removeproduct(item.key)"
              ></span>
            </span>
          </div>
        </li>
      </ul>
      <v-addressformfoot
        toNext="Continue"
        ref="addressformfoot"
        @toNextApi="batch_cart"
        out_stock="out_stock"
      ></v-addressformfoot>
    </div>
  </div>
</template>
<script>
import defaultImage from "../../../../../public/images/no-image.gif";
import API from "../../../API";
export default {
  props: ["out_stock"],
  data() {
    return {
      defaultImage,
      out_stock_list: [],
      batch_update: []
    };
  },
  methods: {
    async batch_cart() {
      try {
        this.out_stock_list.forEach(item => {
          this.batch_update.push({
            row_key: item.key,
            quantity: item.variant ? item.variant.stock : item.product.stock
          });
        });
        let res = await this.$axios.post(API.batch_update, {
          items: this.batch_update
        });
        // console.log(res);
        // this.$store.dispatch("change_news_cart", res.data);
        window.history.go(0);
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },
    async removeproduct(key) {
      try {
        let res = await this.$axios.delete(API.deletecart + key);
        window.history.go(0);
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
      // this.$axios
      //   .delete(API.deletecart + key)
      //   .then(res => {
      //     if (res.status == 200) {
      //       console.log(res);

      //       this.cartmes = res.data;
      //     }
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    }
  },
  beforeMount() {
    this.out_stock_list = this.out_stock;
  },
  mounted() {
    this.$(".stepnav").hide();
    console.log("out_stock", this.out_stock);
  }
};
</script>
<style scoped lang='scss'>
.out_stock {
  color: gray;
  .stock_title {
    h2 {
      word-wrap: break-word;
      word-break: break-word;
      -webkit-font-smoothing: subpixel-antialiased;
      -webkit-box-direction: normal;
      font-weight: normal;
      margin: 0;
      font-size: 18px;
      color: #333333;
    }
    p {
      font-size: 14px;
      word-wrap: break-word;
      word-break: break-word;
      -webkit-font-smoothing: subpixel-antialiased;
      color: #545454;
      -webkit-box-direction: normal;
      margin: 0;
      line-height: 21px;
      margin-top: 3.5px;
    }
  }
  .section {
    font-size: 14px;
    word-wrap: break-word;
    word-break: break-word;
    -webkit-font-smoothing: subpixel-antialiased;
    color: #545454;
    -webkit-box-direction: normal;
    position: relative;
    padding-top: 42px;
    .section_head {
      padding: 24px 0;
      border-bottom: 1px solid #e6e6e6;
      span,
      em {
        display: inline-block;
        word-wrap: break-word;
        word-break: break-word;
        -webkit-font-smoothing: subpixel-antialiased;
        -webkit-box-direction: normal;
        border-collapse: collapse;
        border-spacing: 0;
        font-size: 14px;
        padding: 0;
        padding-left: 0;
        white-space: nowrap;
        font-weight: 500;
        color: #333333;
      }
      em {
        float: right;
      }
    }
    .stock_list {
      .stock_list_item {
        display: flex;
        align-items: center;
        padding: 24px 0;
        border-bottom: 1px solid #e6e6e6;
        .product_img {
          z-index: 1;
          position: relative;
          img {
            display: inline-block;
            width: 65px;
            height: 65px;
            border-radius: 8px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            overflow: hidden;
          }
          span {
            word-wrap: break-word;
            word-break: break-word;
            -webkit-font-smoothing: subpixel-antialiased;
            -webkit-box-direction: normal;
            border-collapse: collapse;
            border-spacing: 0;
            font-size: 12px;
            font-weight: 500;
            white-space: nowrap;
            text-align: center;
            border-radius: 1.75em;
            background-color: rgba(114, 114, 114, 0.9);
            color: #fff;
            box-sizing: border-box;
            position: absolute;
            padding: 0 7px;
            right: -10px;
            top: -10px;
            z-index: 9999;
          }
        }
        .product_name {
          padding-left: 14px;
          flex: 1;
          p {
            margin: 0;
            padding: 0;
          }
          .variant {
            font-size: 12px;
            color: #717171;
            & > span:not(:last-child)::after {
              content: " / ";
            }
          }
        }
        .product_num {
          padding-left: 14px;
          .stock_0 {
            color: #e32c2b;
          }
          .stock_not_enough {
            position: relative;
            span {
              position: absolute;
              right: -30px;
              top: -3px;
              color: rgb(145, 145, 145);
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>